import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { resendVerificationEmail } from "../redux/slices/loginRegister";

const VerifyEmailPending = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const email = location.state?.email || "";

  const [loading, setLoading] = useState(false);
  const [resent, setResent] = useState(false);

  const handleResendVerification = async () => {
    if (!email) {
      toast.error("Email not found. Please login again.");
      return;
    }

    setLoading(true);
    try {
      await dispatch(resendVerificationEmail(email, toast));
      setResent(true);
    } catch (error) {
      // fallback handled in slice
    } finally {
      setLoading(false);
    }
  };

  const handleGoToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="bg-white p-8 rounded-xl shadow-md text-center max-w-md w-full">
        <h2 className="text-3xl font-semibold mb-4 text-red-600">
          Email Not Verified
        </h2>
        <p className="text-gray-700 mb-6">
          Your email <strong>{email}</strong> is not verified.
          <br />
          Please check your inbox for the verification link.
          <br />
          If you did not receive the email, you can resend it below.
        </p>

        <button
          onClick={handleResendVerification}
          disabled={loading || resent}
          className={`mb-4 px-6 py-2 rounded-lg text-white transition ${
            loading || resent
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {loading ? "Sending..." : resent ? "Verification Sent" : "Resend Email"}
        </button>

        <button
          onClick={handleGoToLogin}
          className="mt-2 px-6 py-2 rounded-lg bg-gray-700 hover:bg-gray-800 text-white"
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default VerifyEmailPending;
